export enum PackageBuilderFlow {
  NONE,
  PACKAGE_BUILDER_SUMMARY,
  WHEELS,
  TIRES,
  HARDWARE,
  PACKAGEKITS
}
